import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import { h } from 'vue';
import FormToggle from '@frontend/components/FormToggle';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/transparent_reference.svg';

export function ReferencesTransparent() {
    return SettingsEntry(
        'References transparent',

        'Make reference objects transparent.',

        img(icon),

        h(FormToggle, {
            value: app.settings.reference_transparent,
            'onUpdate:value': x => app.settings.reference_transparent = x,
        }),
    );
}
